import { TradeSubTradeItem } from 'app/models/trade-sub-trade-params'
import * as types from './types'

export const getTradeSubTrades = (payload: { masterTradeId: string; items: TradeSubTradeItem[] }) => ({
  type: types.GET_TRADE_SUB_TRADES,
  payload,
})

export const startLoadingTradeSubTrades = (masterTradeId: string) => ({
  type: types.START_LOADING_TRADE_SUB_TRADES,
  payload: { masterTradeId },
})

export const stopLoadingTradeSubTrades = (masterTradeId: string) => ({
  type: types.STOP_LOADING_TRADE_SUB_TRADES,
  payload: { masterTradeId },
})

/** The trade's read failed: the panel stops its spinner and offers a retry. */
export const failTradeSubTrades = (masterTradeId: string) => ({
  type: types.FAIL_TRADE_SUB_TRADES,
  payload: { masterTradeId },
})
